<div class="common-style h-100 d-flex flex-column">
  <div class="panel-header d-flex align-items-center justify-content-between">
    <div style="width: 48px;"></div>
    <h6 class="model-title mb-0 flex-grow-1 text-center">
      {{ data.mode === 'edit' ? 'Edit Service Group' : 'Add Service Group' }}
    </h6>
    <div class="d-flex align-items-center">
      <button type="button" mat-icon-button class="panel-close-btn" (click)="onCancel()" [disabled]="isSaving">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="panel-body flex-grow-1 overflow-y-auto overflow-x-hidden">
    <form id="groupDialogForm" class="tab-content" [formGroup]="groupForm" (ngSubmit)="onSave()">
      <div class="col-sm-12 mb-3">
        <span class="title-name">Name <span class="mandatory-star">*</span></span>
        <div class="error-input-wrapper">
          <input type="text" class="form-control" placeholder="e.g., API Services" formControlName="name">
          @if (groupForm.get('name')?.hasError('required') && groupForm.get('name')?.touched) {
            <mat-error>Group name is required</mat-error>
          }
          @if (groupForm.get('name')?.hasError('minlength') && groupForm.get('name')?.touched) {
            <mat-error>Group name must be at least 3 characters</mat-error>
          }
          @if ((groupForm.get('name')?.hasError('pattern') || groupForm.get('name')?.hasError('invalidName')) && groupForm.get('name')?.touched) {
            <mat-error>Group name is invalid</mat-error>
          }
        </div>
      </div>

      <div class="col-sm-12 mb-3">
        <span class="title-name">Description</span>
        <div class="error-input-wrapper">
          <textarea class="form-control" rows="3" placeholder="e.g., Core API services and endpoints"
            formControlName="description"></textarea>
          @if (groupForm.get('description')?.hasError('invalidName') && groupForm.get('description')?.touched) {
            <mat-error>Description is invalid</mat-error>
          }
        </div>
      </div>
    </form>
  </div>

  <div class="panel-footer d-flex justify-content-end gap-2 align-items-center">
    <button type="button" class="bt-border" mat-raised-button (click)="onCancel()" [disabled]="isSaving">Cancel</button>
    <button type="submit" class="bt-background ms-3" mat-raised-button [disabled]="isSaving || groupForm.invalid" form="groupDialogForm">
      @if (isSaving) {
        <mat-spinner diameter="16" class="d-inline-block me-2" style="vertical-align: middle;"></mat-spinner>
      }
      Add Service Group
    </button>
  </div>
</div>
